import InnerHTMLWithScript from "../../../components/innerhtmlwithscript/innerhtmlwithscript"
import SBEditable from "../../../components/sbEditable/sbEditable"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"

import styles from "./tiktokembed.module.scss"

const TIKTOK_SCRIPT =
  '<script async src="https://www.tiktok.com/embed.js"></script>';

function TikTokEmbed({ blok }) {
  //Add the tiktok script tag for those that don't have it
  // If it is already there helmet will remove the duplicate
  const tiktokWithScript = blok.tiktok + TIKTOK_SCRIPT;

  return (
    <SBEditable
      blok={blok}
      withClass={`${ArticlePanelOptionsToClasses(blok)} ${styles.wrapper}`}
    >
      <div
        className={`${styles.tiktok} div-align-${blok.alignment || "left"}`}
        style={{ maxWidth: blok.maxwidth ? `${blok.maxwidth}px` : 520 }}
      >
        <InnerHTMLWithScript id={blok._uid} text={tiktokWithScript} />
      </div>
    </SBEditable>
  );
}

export default TikTokEmbed